import request from '@/utils/request'

// 终端列表查询
export function getClientVisitMap (params) {
  return request({
    url: '/v1/adb/sca_visit_client/search',
    method: 'post',
    data: params
  })
}

// 添加或提交拜访
export function addOrCommitVisit (params) {
  return request({
    url: '/v1/adb/sca_visit_client/addOrCommitVisit',
    method: 'post',
    data: params
  })
}

// 获取终端信息
export function getClientInfo (matchClientId) {
  return request({
    url: '/v1/adb/sca_visit_client/client_info' + '/' + matchClientId,
    method: 'get'
  })
}

// 产品列表查询
export function getProductList () {
  return request({
    url: '/v1/adb/sca_visit_client/product_list',
    method: 'get'
  })
}

// 竞品列表查询
export function getCompetitiveProductList (cityCode) {
  return request({
    url: '/v1/adb/sca_visit_client/competitive_product_list' + '/' + cityCode,
    method: 'get'
  })
}

// 获取我的拜访记录
export function getMyVisitRecord () {
  return request({
    url: '/v1/adb/sca_visit_client/my_visit_record',
    method: 'get'
  })
}

// 获取终端拜访记录
export function getClientVisitRecord (matchClientId) {
  return request({
    url: '/v1/adb/sca_visit_client/client_visit_record' + '/' + matchClientId,
    method: 'get'
  })
}

// 获取拜访记录详情
export function getVisitRecordDetails (recordId) {
  return request({
    url: '/v1/adb/sca_visit_client/visit_record_details' + '/' + recordId,
    method: 'get'
  })
}
